// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"CanadaModal_buttonContainer__UQPem","button":"CanadaModal_button__29Dmf"};